export default {
  path: 'secondhand',
  meta: {
    title: '二手交易'
  },
  name: 'secondhand',
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'publish',
      name: 'self-secondhand-publish',
      meta: {
        title: '二手发布'
      },
      component: () => import('@/view/v5/secondhand/index.vue')
    },
    {
      path: '',
      meta: {
        title: '我的发布'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'mypublish',
          name: 'self-secondhand-mypublish',
          meta: {
            title: '我的发布'
          },
          component: () => import('@/view/v5/secondhand/mypublish.vue')
        },
        {
          path: 'ask',
          name: 'self-secondhand-ask',
          meta: {
            title: '咨询人数',
            hideInTabBar: true
          },
          component: () => import('@/view/v5/secondhand/ask.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/secondhand.js